import React, { useState, useEffect, useContext, useRef } from "react";

import { useQueryParams } from "../../hooks/useQueryParams";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { AccesibilidadContext } from "../../contexts/AccesibilidadContext";

import BotonesCita from "./botonesCita";
import PasosCita from "./pasosCita";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";

import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
/**
 * En este componente va todo el flujo de funcionamiento para la compra institucional (agendamiento). Para los calendarios usamos Calendly, este nos permite vincular cuentas de correo y relacionarlo con sus respectivos calendarios.  Este componente hace uso de los componentes BotonesCita y PasosCita.
 */
export const TiendaClienteInstitucional = () => {
    const {textosSubSecciones:textos} = useObtenerSubsecciones('tienda_makemake');
    const [cita, setCita] = useState('');
    const [pasoActivo, setPasoActivo] = useState('idioma_cita');
    const [backgroundCalendar, setBackgroundCalendar] = useState('#FFFFFF');
    const [primaryColor, setPrimaryColor] = useState('#82559E');
    const [textColor, setTextColor] = useState('#4d5055');
    const [alturaCalendario, setAlturaCalendario] = useState('1000px');
    const params = useQueryParams();
    const accebilidadState = useContext(AccesibilidadContext);
    const [calendlyRef, setCalendlyRef] = useState(null);
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const citaIdioma = params.get('idioma');
        if (!!citaIdioma) {
            setCita(citaIdioma)
        } else {
            setCita('')
            setPasoActivo('idioma_cita');
        }
    }, [params])

    useEffect(() => {
        if (accebilidadState?.temaActual !== 'clasico') {
            setBackgroundCalendar('#000000');
            setPrimaryColor('#ffff00');
            setTextColor('#ffff00');
        } else {
            setBackgroundCalendar('#FFFFFF');
            setPrimaryColor('#82559E');
            setTextColor('#4d5055');
        }
    }, [accebilidadState])

    useEffect(() => {
        const isLoadingCalendly = calendlyRef?.state?.isLoading;
        setLoading(isLoadingCalendly);
    }, [calendlyRef?.state?.isLoading])

    useCalendlyEventListener({

        onEventTypeViewed: () => {
            setPasoActivo('escoge_cita');
            setAlturaCalendario('1000px')
        },
        onDateAndTimeSelected: () => {
            setAlturaCalendario('1500px')
            setPasoActivo('informacion');
        },

        onEventScheduled: (e) => {
            /* console.log(e.data.payload) */
            setAlturaCalendario('700px')
            setPasoActivo('confirmacion');
        },

        onProfilePageViewed: () => console.log("onProfilePageViewed----------------------"),

    });

    // console.log('paso y carga', pasoActivo, loading, calendlyRef.current)


    return (
        <div className="institucional-section">
            <section className="container py-5">
                <div className="d-flex institucional-title">
                    <hr className="institucional-line" aria-hidden={true} />
                    <h2 className="onbackground-primary--color flex-grow-1 w-100 text-center">{textos?.institucional?.cita?.titulo || 'Pide una cita'}</h2>
                    <hr className="institucional-line" aria-hidden={true} />
                </div>
                <div className="tienda-institucional ">
                    <div className=" col-lg-3">
                        <div className="contenedor-pasos mt-5 mb-5 mb-md-0">
                            <PasosCita pasoActivo={pasoActivo} onClickStep={(step) => {
                                if (step === 1) {
                                    history.push('/tienda/institucional');
                                    setLoading(false);
                                }
                            }} />
                        </div>
                    </div>
                    <div className=" col-lg-9 ">
                        {cita === '' && <BotonesCita onClickSpanishMeet={() => {
                            setPasoActivo('escoge_cita');
                            history.push('/tienda/institucional?idioma=es')
                        }} />}

                        {loading &&
                            pasoActivo !== 'idioma_cita' &&
                            <div className="w-100 h-100 d-flex justify-content-center align-items-center justify-center align-self-center">
                                <Icon className={'spinner-rotation onbackground-primary--color'} icon="icomoon-free:spinner9" width={60} />
                            </div>
                        }
                        {cita === 'es' &&
                            <InlineWidget
                                url="https://calendly.com/comunicacion-62/30min"
                                styles={{
                                    height: loading ? 0 : alturaCalendario,
                                }}
                                ref={(el) => setCalendlyRef(el)}
                                pageSettings={{
                                    backgroundColor: backgroundCalendar,
                                    hideEventTypeDetails: true,
                                    hideLandingPageDetails: true,
                                    primaryColor: primaryColor,
                                    textColor: textColor
                                }}
                            />
                        }

                        {cita === 'en' &&
                            <InlineWidget
                                ref={calendlyRef}
                                url="https://calendly.com/comunicacion-62/meeting-in-english"
                                styles={{
                                    height: loading ? 0 : alturaCalendario,
                                }}
                                pageSettings={{
                                    backgroundColor: backgroundCalendar,
                                    hideEventTypeDetails: true,
                                    hideLandingPageDetails: true,
                                    primaryColor: primaryColor,
                                    textColor: textColor
                                }}
                            />
                        }
                    </div>
                </div>
            </section>
        </div>
    )
}